import React from 'react';
import { 
  Box, 
  Button, 
  TextField, 
  useTheme,
  styled,
  InputAdornment,
  IconButton,
  Tooltip
} from '@mui/material';
import { Search, Clear, FilterAlt, Add } from '@mui/icons-material';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
  },
  '& .MuiInputLabel-root': {
    color: theme.palette.text.secondary,
  },
}));

const FilterControls = ({ filterType, onFilterChange, onOpenDialog }) => {
  const theme = useTheme();

  return (
    <Box sx={{ 
      mb: 3, 
      display: 'flex', 
      gap: 2,
      alignItems: 'center',
      flexWrap: 'wrap'
    }}>
      <StyledTextField
        label="Filter categories"
        variant="outlined"
        value={filterType}
        onChange={(e) => onFilterChange(e.target.value)}
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search color="action" />
            </InputAdornment>
          ),
          endAdornment: filterType && (
            <IconButton
              size="small"
              onClick={() => onFilterChange('')}
              sx={{ visibility: filterType ? 'visible' : 'hidden' }}
            >
              <Clear fontSize="small" />
            </IconButton>
          )
        }}
        sx={{
          minWidth: 250,
          flexGrow: 1
        }}
      />

      <Tooltip title="Clear filters">
        <Button
          variant="outlined"
          onClick={() => onFilterChange('')}
          startIcon={<FilterAlt />}
          disabled={!filterType}
          sx={{
            borderRadius: theme.shape.borderRadius,
            textTransform: 'none',
            px: 3
          }}
        >
          Clear
        </Button>
      </Tooltip>
    </Box>
  );
};

export default FilterControls;